// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // This should import Tailwind
import App from './App';

// Disable SW in development
if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}
/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        console.log('SW registered');
        
        // Check for updates immediately
        reg.update();
        
        // Check for updates every 60 seconds
        setInterval(() => {
          reg.update();
        }, 60000);
      })
      .catch((err) => console.log('SW failed:', err));
  });
}
*/
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);